import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=07fef96e&scoped=true"
import script from "./ConfigList.vue?vue&type=script&lang=ts"
export * from "./ConfigList.vue?vue&type=script&lang=ts"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=07fef96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fef96e",
  null
  
)

export default component.exports